import http from "../http-common";

const PostUserBasedAnalytics = async (data) => {
  const newData = await http
    .post(`/usersAnalytics`, data)
    .then((response) => {
      return response.data;
    });
  return newData;
};
const PostVisitBasedAnalytics = async (data) =>{
  const newData =await http
  .post('/visitAnalytics',data)
  .then((response)=>{
    return response.data
  })
  return newData
}

const AnalyticsAPI = {
    PostUserBasedAnalytics,
    PostVisitBasedAnalytics
};

export default AnalyticsAPI;
